import { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import { Grid, Tooltip, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getMomentFormat } from "constants/dateTime.constant";
import moment from "moment";
import { useTranslation } from "react-i18next";
import Loader from "components/loader/loader";
import { getDidNotFountList } from "store";
export default function DidNotFoundList() {
  let page = 1;
  const perPage = 10;
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [perPageRows, setNumberOfRows] = useState(perPage);
  const [sortColumn, setSortColumn] = useState("");
  const [sortOrder, setSortOrder] = useState(-1);
  const [isLoading, setIsLoading] = useState(false);
  const [pageCheck, setPageCheck] = useState(1);
  const { didNotFoundListData, totalDidNotFoundCount } = useSelector((state) => state.couponSlice);
  useEffect(() => {
    fetchDidNotFoundList();
  }, []);
  console.log("didNotFoundListData", didNotFoundListData);
  const options = {
    count: totalDidNotFoundCount,
    filter: false,
    pagination: true,
    selectableRows: "none",
    usePaperPlaceholder: false,
    elevation: 0,
    filterType: "dropdown",
    responsive: "vertical",
    print: false,
    download: false,
    viewColumns: false,
    search: false,
    serverSide: true,
    rowsPerPage: [perPageRows],
    rowsPerPageOptions: [10, 20, 50, 100],
    textLabels: {
      pagination: {
        next: "Next",
        previous: "Previous",
        rowsPerPage: t("category.rowsPerPage"),
        displayRows: "of"
      },
      body: {
        noMatch: `Record Not Found`,
        toolTip: "Sort",
        columnHeaderTooltip: (column) => `Sort for ${column.label}`
      }
    },
    onColumnSortChange: (changedColumn, direction) => {
      let sortingOrder = direction === "asc" ? 1 : -1;
      setSortOrder(sortingOrder);
      setSortColumn(changedColumn);
      fetchDidNotFoundList("", "", changedColumn, sortingOrder);
    },

    onChangePage(currentPage) {
      if (currentPage >= pageCheck) {
        if (currentPage === 0) {
          currentPage = currentPage + 1;
        }
        setPageCheck(currentPage);
        page = currentPage + 1;
        fetchDidNotFoundList(page, "", "", "");
      } else {
        if (pageCheck > 0) {
          page = pageCheck - 1;
        }
        setPageCheck(page);
        fetchDidNotFoundList(page, "", "", "");
      }
    },
    onChangeRowsPerPage(numberOfRows) {
      setNumberOfRows(numberOfRows);
      fetchDidNotFoundList("", numberOfRows, "", "");
    }
  };

  const columns = [
    {
      name: "email",
      label: t("login.email"),
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return (
            <Tooltip title={value}>
              <Typography
                style={{
                  fontSize: 14
                }}>
                {value ? value : "-"}
              </Typography>
            </Tooltip>
          );
        }
      }
    },
    {
      name: "whatsAppNo",
      label: t("users.phone"),
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return (
            <Tooltip title={value}>
              <Typography
                style={{
                  fontSize: 14
                }}>
                {value ? value : "-"}
              </Typography>
            </Tooltip>
          );
        }
      }
    },

    {
      name: "message",
      label: t("didNotFound.message"),
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return (
            <Tooltip title={value}>
              <Typography>{value ? value : "-"}</Typography>
            </Tooltip>
          );
        }
      }
    },

    {
      name: "createdAt",
      label: t("products.createdAt"),
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          var localTime = moment.utc(value).toDate();
          return <div style={{ alignItems: "center" }}>{getMomentFormat(localTime)}</div>;
        }
      }
    }
  ];

  const fetchDidNotFoundList = (page, numberOfRows, sortingColumnValue, sortingOrder) => {
    setIsLoading(true);
    var data = {
      page: page ? page : 1,
      perPage: numberOfRows ? numberOfRows : perPageRows,
      language: i18n?.language,
      sort: {
        sortField: sortingColumnValue !== "" ? sortingColumnValue : sortColumn,
        sortIn: sortingOrder !== "" ? sortingOrder : sortOrder
      }
    };

    dispatch(getDidNotFountList(data, setIsLoading));
  };

  return (
    <Grid container>
      <Grid
        container
        sx={{
          border: " 1px solid rgba(224, 224, 224, 1)",
          p: 2,
          backgroundColor: "white"
        }}>
        <Grid sx={{ mt: 1 }}>
          <Typography variant="body1" sx={{ fontSize: 18 }} color="secondary.contrastText">
            {t("didNotFound.listTitle")}
          </Typography>
        </Grid>
      </Grid>
      {isLoading ? (
        <>
          <Grid
            container
            sx={{
              border: "1px solid rgba(224, 224, 224, 1)",
              mt: 2,
              height: 300,
              backgroundColor: "white"
            }}>
            <Grid xs={12} style={{ display: "flex", justifyContent: "center" }}></Grid>
          </Grid>
        </>
      ) : (
        <>
          {didNotFoundListData && didNotFoundListData.length > 0 ? (
            <Grid container>
              <Grid xs={12}>
                <MUIDataTable data={didNotFoundListData} columns={columns} options={options} />
              </Grid>
            </Grid>
          ) : (
            <>
              <Grid
                container
                sx={{
                  border: "1px solid rgba(224, 224, 224, 1)",
                  mt: 2,
                  height: 300,
                  backgroundColor: "white"
                }}>
                <Grid xs={12} style={{ display: "flex", justifyContent: "center" }}>
                  <Typography sx={{ fontSize: 24, fontWeight: 500, mt: "7.5rem" }}>
                    {t("category.noRecordFound")}
                  </Typography>
                </Grid>
              </Grid>
            </>
          )}
        </>
      )}
      {isLoading && <Loader open={isLoading} text={t("adrena.pleaseWait")} />}
    </Grid>
  );
}
